import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PrimaryLink } from 'jl-design-system/elements/link/Link';

import urlConstants from '../../constants/urlConstants';
import styles from './order-complete-notifications.scss';

export default class OrderCompleteNotification extends PureComponent {
  static defaultProps = {
    browseUrl: urlConstants.HOME_PAGE_URL,
  };

  static propTypes = {
    browseUrl: PropTypes.string,
  };

  render() {
    const { browseUrl } = this.props;

    return (
      <div className={styles.orderCompleteNotification}>
        <h2 className={styles.title}>Your order is complete</h2>
        <p>You can either exit your browser or continue to browse our website</p>
        <PrimaryLink
          className={styles.continueShoppingLink}
          data-action="handback"
          to={browseUrl}
        >
          Continue shopping
        </PrimaryLink>
      </div>
    );
  }
}
